export default __webpack_public_path__ + "components/carousel-nearby-mountains/static/generic-bg--5-b195416203f8b4d20e5724eaa0d21714.jpg";